import { PaginatedData, PaginationParams } from 'models/Pagination';
import { User } from 'models/User';
import httpClient from '../../httpClient';

function getManagers(params?: PaginationParams) {
  return httpClient.get<PaginatedData<User>>('users', {
    params,
  });
}

function deleteManager(managerId: string) {
  return httpClient.delete(`users/${managerId}`);
}

function addManager(manager: Partial<User>) {
  return httpClient.post<User>(`users`, manager);
}

export default {
  getManagers,
  deleteManager,
  addManager,
};
